import { Tile, Wind, WINDS, generateWall, shuffleWall } from './Tiles';
import { Player, PlayerIndex } from './Player';

export type GameState = 'setup' | 'paused' | 'running' | 'end';

export interface GameBoard {
    wall: Tile[];
    deadWall: Tile[];
    doraIndicators: Tile[];
    players: Player[];
    currentTurn: number;
    roundWind: Wind;
    gameState: GameState;
}

export function playTurn(game: GameBoard, tileIndex: number): GameBoard {
    if (game.gameState !== 'running') {
        return game;
    }

    const player = game.players[game.currentTurn];

    // 1. Discard the selected tile
    player.discard(tileIndex);

    // 2. Advance turn to next player
    game.currentTurn = (game.currentTurn + 1) % 4;

    // 3. Next player draws from the wall
    if (game.wall.length > 0) {
        const nextPlayer = game.players[game.currentTurn];
        const drawnTile = game.wall.shift();
        if (drawnTile) {
            nextPlayer.draw(drawnTile);
        }
    } else {
        game.gameState = 'end';
    }

    // Return a shallow copy to trigger React re-render
    return { ...game };
}

export function createNewGame(): GameBoard {
    const fullWall = shuffleWall(generateWall());

    // Separate Dead Wall (14 tiles)
    // The dead wall is the last 14 tiles of the shuffled wall.
    const deadWall = fullWall.slice(-14);
    const playWall = fullWall.slice(0, -14);

    // Dora Indicators (Top tiles of the 5 stacks in the dead wall reserved for Dora)
    // Indices 0-3 are Rinshan (replacement tiles).
    // Indices 4-13 are Dora/Ura indicators (5 stacks of 2).
    // The visible indicators are the top tiles of these stacks: indices 4, 6, 8, 10, 12.
    const doraIndicators = [
        deadWall[4],
        deadWall[6],
        deadWall[8],
        deadWall[10],
        deadWall[12]
    ];

    const players: Player[] = [];
    let wallIndex = 0;

    for (let i = 0; i < 4; i++) {
        const hand = playWall.slice(wallIndex, wallIndex + 13);
        wallIndex += 13;
        players.push(new Player(i as PlayerIndex, WINDS[i], hand));
    }

    // Dealer (East) draws the 14th tile
    players[0].draw(playWall[wallIndex]);
    wallIndex++;

    return {
        wall: playWall.slice(wallIndex),
        deadWall,
        doraIndicators,
        players,
        currentTurn: 0,
        roundWind: 'east',
        gameState: 'running',
    };
}
